import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

const BaseButton = styled.button`
  ${mediaQuery.desktop`
background-color: ${(props) => (props.bgColor ? props.bgColor : '#549A9A')};
justify-content: center;
color: ${(props) => (props.color ? props.color : '#fff')};
display: none;
position: fixed;
align-items: center;
cursor: pointer;
width: 100%;
top: 89%;
left: 95%;
transform: translate(-95%, -89%);
z-index: 200;
border: none;
height: 3em;
`}
  background-color: ${(props) => (props.bgColor ? props.bgColor : '#549A9A')};
  justify-content: center;
  color: #fff;
  display: flex;
  position: fixed;
  align-items: center;
  cursor: pointer;
  width: 100%;
  top: 89%;
  left: 95%;
  transform: translate(-95%, -89%);
  z-index: 200;
  border: none;
  height: 3em;

  @media screen and (max-width: 992px) {
    font-size: 16px;
  }
  @media screen and (min-width: 1024px) and (max-width: 1400px) {
    font-size: 20px;
  }
`;

export const FloatButton = ({ onClick, text, icon, ...props }) => {
  return (
    <BaseButton onClick={onClick} {...props}>
      {icon && <img src={icon} alt={icon} />}
      {text}
    </BaseButton>
  );
};

FloatButton.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

FloatButton.defaultProps = {
  onClick: () => {},
};
